import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import CustomHeading from "components/UIComponents/Typography/Heading";
import { Accordion } from "@chakra-ui/react";
import FaqItem from "./FaqItem";
import { ReactNode } from "react";
import "./FaqBlockStyles.css";
import MainPageSection from "components/Layout/MainPageSection";
import { FormattedMessage, useIntl } from "react-intl";

type FaqItemType = {
  title: string;
  content: ReactNode;
};

const FaqBlock = () => {
  const intl = useIntl();

  const faqItems: FaqItemType[] = [
    {
      title: intl.formatMessage({ id: "AbuseIpDbTitle" }),
      content: <FormattedMessage id="AbuseIpDbContent" />,
    },
    {
      title: intl.formatMessage({ id: "IpIntelTitle" }),
      content: <FormattedMessage id="IpIntelContent" />,
    },
    {
      title: intl.formatMessage({ id: "ProxstopTitle" }),
      content: (
        <div>
          <FormattedMessage id="ProxstopContent" />
          <TableContainer>
            <Table size="lg" mt={5} variant="striped" colorScheme="blue">
              <Thead>
                <Tr>
                  <Th>
                    <FormattedMessage id="ScoreText" />
                  </Th>
                  <Th>
                    <FormattedMessage id="InfoText" />
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                <Tr>
                  <Td>1</Td>
                  <Td>
                    <FormattedMessage
                      id="ProxstopTableFirstRow"
                      values={{
                        br: <br />,
                      }}
                    />
                  </Td>
                </Tr>
                <Tr>
                  <Td>2</Td>
                  <Td>
                    <FormattedMessage id="ProxstopTableSecondRow" />
                  </Td>
                </Tr>
                <Tr>
                  <Td>3-5</Td>
                  <Td>
                    <FormattedMessage id="ProxstopTablThirdRow" />
                  </Td>
                </Tr>
              </Tbody>
            </Table>
          </TableContainer>
        </div>
      ),
    },
  ];
  return (
    <MainPageSection>
      <section className="faq-block">
        <CustomHeading className="section-heading faq-block-heading">
          <FormattedMessage id="FAQ" />
        </CustomHeading>
        <main className="faq-block-inner">
          <Accordion allowToggle>
            {faqItems.map((item, index) => (
              <FaqItem key={index} item={item} />
            ))}
          </Accordion>
        </main>
      </section>
    </MainPageSection>
  );
};

export default FaqBlock;
